import React, {Fragment} from 'react';
import {DragIndicatorOutlined as DragIcon} from '@material-ui/icons';
import {Typography} from '@material-ui/core';
import {InfoIcon} from 'components';
import { roundToFixed } from 'services/util/helperFuncs'; 
import {DurationCell} from "./durationCell";
import TemplateMetaDataCell from "./templateMetaDataCell";

const Columns = {
  templateNumber: {
    name: 'templateNumber',
    header: ({ t, classes }) => (
      <div>
        {t('templateNumber')}&nbsp;
        <InfoIcon className={classes.infoIcon} descriptionKey={'70'} />
      </div>
    ),
    body: ({ template, provided, classes, filter, snapshot, t }) => (
      <Fragment>
        <div {...provided.dragHandleProps} className={classes.dragIcon}>
          <DragIcon />
        </div>
        {snapshot.isDragging ? (
          <Typography variant={'body1'}>
            <strong>{t('templateNumber')}:</strong>{' '}
            {template.templateNumber + ' | '}
            <strong>{t('templateId')}:</strong> {template.id + ' | '}
            <strong>{t('templateName')}:</strong> {template.templateName}
          </Typography>
        ) : (
          template.templateNumber
        )}
      </Fragment>
    ),
  },
  templateId: {
    name: 'templateId',
    header: ({ t }) => t('templateId'),
    body: ({ template, provided }) => (
      <div ref={provided.innerRef} {...provided.droppableProps}>
        {template.id}
      </div>
    ),
  },
  templateName: {
    name: 'templateName',
    header: ({ t }) => t('templateName'),
    body: ({ template, provided }) => (
      <div ref={provided.innerRef} {...provided.droppableProps}>
        {template.templateName}
      </div>
    ),
  },
  carrier: {
    name: 'carrier',
    header: ({ t }) => t('carrier'),
    body: ({ template, provided }) => (
      <div ref={provided.innerRef} {...provided.droppableProps}>
        {template.carrierName}
      </div>
    ),
  },
  microHub: {
    name: 'microHub',
    header: ({ t }) => t('microHub'),
    body: ({ template, provided }) => (
      <div ref={provided.innerRef} {...provided.droppableProps}>
        {template.microHubName}
      </div>
    ),
  },
  templateTemplateStops: {
    name: 'templateTemplateStops',
    header: ({ t }) => t('templateTemplateStops'),
    body: ({ template, provided }) => (
      <div ref={provided.innerRef} {...provided.droppableProps}>
        {template.stops?.length || 0}
      </div>
    ),
  },
  shipper: {
    name: 'shipper',
    header: ({ t }) => t('shipper'),
    body: ({ template, provided }) => (
      <div ref={provided.innerRef} {...provided.droppableProps}>
        {template.shipperName}
      </div>
    ),
  },
  duration: {
    name: 'duration',
    header: ({t}) => t('duration'),
    body: ({template, t}) => <DurationCell template={template} t={t}/>,
  },
  lengthKm: {
    name: 'lengthKm',
    header: ({ t }) => t('length'),
    body: ({ template }) => roundToFixed(template.distanceInKm, 2),
  },
  templateMetaData: {
    name: 'templateMetaData',
    header: ({ t }) => t('templateMetaData'),
    body: ({ template, t }) => (
        <TemplateMetaDataCell template={template} t={t}/>
    ),
  },

};

export default Columns;
